<div fxLayout="column" fxLayoutGap="5px">
    <div fxFlex="1 1 auto" fxLayoutGap="5px">
        <button pButton pRipple type="button" class="p-button-raised dashboard-button" label="Submit for Approval"
            icon="pi pi-send" (click)="showSubmitDialog=true" [disabled]="!submitEnabled()">
        </button>
        <button pButton pRipple type="button" class="p-button-raised dashboard-button" label="Approve"
            icon="pi pi-thumbs-up" (click)="showApproveDialog=true" [disabled]="!approveEnabled()">
        </button>
        <button pButton pRipple type="button" class="p-button-raised dashboard-button" label="Reject"
            icon="pi pi-thumbs-down" (click)="showRejectDialog=true" [disabled]="!rejectEnabled()">
        </button>
    </div>
    <p-table fxFlex="1 1 auto" [value]="customerManagedRecordModifications" [loading]="loading"
        [(selection)]="selectedCustomerManagedRecordModifications" dataKey="itemKey"
        [scrollable]="true" scrollHeight="flex" [style.height]="'85vh'">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5vw;text-align: 'center'">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th style="width: 35vw; text-align: 'center'">Item</th>
                <th style="width: 8vw; text-align: 'center'">Status</th>
                <th style="width: 10vw; text-align: 'center'">Submitted By</th>
                <th style="width: 10vw; text-align: 'center'">Submit Time</th>
                <th style="width: 10vw; text-align: 'center'">Authorized By</th>
                <th style="width: 12vw; text-align: 'center'">Authorized Time</th>
                <th> </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-record>
            <tr>
                <td style="width: 5vw;text-align: 'center'">
                    <p-tableCheckbox [value]="record"></p-tableCheckbox>
                </td>
                <td style="width: 35vw; text-align: 'center'">{{record.itemLocation}}</td>
                <td style="width: 8vw; text-align: 'center'">
                    <span [class]="'status-badge status-' + record.status">{{record.status}}</span>
                </td>
                <td style="width: 10vw; text-align: 'center'">{{record.submitUser}}</td>
                <td style="width: 10vw; text-align: 'center'">{{record.submitDatetime}}</td>
                <td style="width: 10vw; text-align: 'center'">{{record.authorizedUser}}</td>
                <td style="width: 10vw; text-align: 'center'">{{record.authorizedDatetime}}</td>
                <td style="width: 12vw; align-content: 'center'" fxLayoutGap="10px">
                    <button pButton pRipple icon="pi pi-info" class="p-button-rounded p-button-outlined p-button-info"
                        (click)="onInfo(record)"></button>
                    <button pButton pRipple icon="pi pi-external-link" class="p-button-rounded p-button-outlined p-button-info"
                        (click)="onLink(record)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>


<p-dialog header="Submit selected for approval" [(visible)]="showSubmitDialog" [modal]="true" [style]="{width: '30vw'}">
    <span class="p-float-label">
        <textarea id="commentsArea" pInputTextarea [(ngModel)]="comments" [style]="{width: '100%'}"></textarea>
        <label for="commentsArea">Comments</label>
    </span>
    <ng-template pTemplate="footer">
        <p-button (click)="showSubmitDialog=false" label="Cancel" styleClass="p-button-text"></p-button>
        <p-button (click)="onSubmitConfirm()" label="Submit" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Approve" [(visible)]="showApproveDialog" [modal]="true" [style]="{width: '30vw'}">
    <span class="p-float-label">
        <textarea id="commentsArea" pInputTextarea [(ngModel)]="comments" [style]="{width: '100%'}"></textarea>
        <label for="commentsArea">Comments</label>
    </span>
    <ng-template pTemplate="footer">
        <p-button (click)="showApproveDialog=false" label="Cancel" styleClass="p-button-text"></p-button>
        <p-button (click)="onApproveConfirm()" label="Approve" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Reject" [(visible)]="showRejectDialog" [modal]="true" [style]="{width: '30vw'}">
    <span class="p-float-label">
        <textarea id="commentsArea" pInputTextarea [(ngModel)]="comments" [style]="{width: '100%'}"></textarea>
        <label for="commentsArea">Comments</label>
    </span>
    <ng-template pTemplate="footer">
        <p-button (click)="showRejectDialog=false" label="Cancel" styleClass="p-button-text"></p-button>
        <p-button (click)="onRejectConfirm()" label="Reject" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Details" [(visible)]="showInfo && infoRecordModification" [modal]="true" [style]="{width: '50vw'}">
    <ng-container *ngIf="infoRecordModification">
        <p-table styleClass="p-datatable-striped" [value]="[{}]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 20%"> </th>
                    <th style="width: 80%"> </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body">
                <tr>
                    <td style="text-align: 'right'">Modified Datetime:</td>
                    <td style="text-align: 'right'">{{infoRecordModification.modifiedDatetime}}</td>
                </tr>
                <tr>
                    <td style="text-align: 'right'">Submitted By:</td>
                    <td style="text-align: 'right'">{{infoRecordModification.submitUser}}</td>
                </tr>
                <tr>
                    <td style="text-align: 'right'">Submitter Comment:</td>
                    <td style="text-align: 'right'">{{infoRecordModification.submitComment}}</td>
                </tr>
                <tr>
                    <td style="text-align: 'right'">Authorizer:</td>
                    <td style="text-align: 'right'">{{infoRecordModification.authorizedUser}}</td>
                </tr>
                <tr>
                    <td style="text-align: 'right'">Authorizer Comment:</td>
                    <td style="text-align: 'right'">{{infoRecordModification.authorizationComment}}</td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
    <ng-template pTemplate="footer">
        <p-button (click)="showInfo=false" label="Ok" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>